// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Phone: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 13"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M11.358 8.248L8.972 7.225a1.07 1.07 0 00-1.236.307l-.777.948a7.374 7.374 0 01-2.937-2.936l.95-.778c.367-.303.488-.8.3-1.239l-1.02-2.386A1.065 1.065 0 003.038.527L.824 1.04A1.056 1.056 0 000 2.073C0 7.822 4.678 12.5 10.427 12.5c.498 0 .924-.338 1.036-.823l.51-2.215a1.065 1.065 0 00-.615-1.214zm-.626 3.26a.315.315 0 01-.304.242C5.09 11.75.75 7.41.75 2.073c0-.145.1-.27.243-.302l2.213-.513a.313.313 0 01.357.18L4.584 3.82a.314.314 0 01-.089.366l-1.183.97a.374.374 0 00-.099.455 8.118 8.118 0 003.678 3.677.374.374 0 00.455-.099l.97-1.183a.316.316 0 01.364-.09l2.38 1.02c.14.06.215.21.182.357l-.51 2.215z" />
        </svg>
    );
};

export default React.memo(Phone);
